"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  RemoveButton: ['remove-button', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,8a3,3,0,0,0-3-3H3A3,3,0,0,0,0,8v8a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-2,8a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V8A1,1,0,0,1,3,7H21a1,1,0,0,1,1,1Z', 'M13.676,15.249a.873.873,0,0,0,1.219,0l1.785-1.785a.346.346,0,0,1,.488,0l1.785,1.785a.875.875,0,0,0,1.218,0,.861.861,0,0,0,0-1.219l-1.785-1.785a.345.345,0,0,1,0-.487l1.785-1.785a.862.862,0,0,0-1.218-1.219l-1.785,1.785a.345.345,0,0,1-.488,0L14.9,8.754a.862.862,0,1,0-1.219,1.219l1.785,1.785a.343.343,0,0,1,0,.487L13.676,14.03A.863.863,0,0,0,13.676,15.249Z']],
  RemoveBadgeAlternate: ['remove-badge-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.031,9.978,21.194,8.5a.594.594,0,0,1-.219-.528l.255-2.345a2.592,2.592,0,0,0-2.858-2.859l-2.346.255a.584.584,0,0,1-.527-.218L14.021.967a2.594,2.594,0,0,0-4.043,0L8.5,2.805a.589.589,0,0,1-.528.219L5.628,2.769A2.593,2.593,0,0,0,2.769,5.628l.256,2.344a.6.6,0,0,1-.218.528L.967,9.978a2.6,2.6,0,0,0,0,4.043L2.805,15.5a.6.6,0,0,1,.22.529L2.769,18.37a2.593,2.593,0,0,0,2.858,2.86l2.346-.256a.579.579,0,0,1,.527.219L9.978,23.03a2.593,2.593,0,0,0,4.043,0L15.5,21.194a.594.594,0,0,1,.528-.22l2.345.256a2.593,2.593,0,0,0,2.859-2.859l-.255-2.346a.59.59,0,0,1,.218-.527l1.839-1.478a2.593,2.593,0,0,0,0-4.042Zm-1.253,2.483L19.94,13.94a2.575,2.575,0,0,0-.953,2.3l.255,2.346a.589.589,0,0,1-.17.483.6.6,0,0,1-.484.17l-2.346-.255a2.588,2.588,0,0,0-2.3.953l-1.478,1.838a.61.61,0,0,1-.924,0l-1.479-1.839a2.577,2.577,0,0,0-2.017-.969,2.772,2.772,0,0,0-.286.016l-2.346.255a.6.6,0,0,1-.482-.17.587.587,0,0,1-.171-.483l.256-2.347a2.586,2.586,0,0,0-.953-2.3L2.221,12.462a.6.6,0,0,1,0-.925l1.839-1.478a2.583,2.583,0,0,0,.954-2.3L4.757,5.41a.592.592,0,0,1,.654-.653l2.346.255a2.584,2.584,0,0,0,2.3-.952l1.479-1.839h0a.611.611,0,0,1,.923,0L13.94,4.06a2.579,2.579,0,0,0,2.3.952l2.346-.255a.592.592,0,0,1,.653.654l-.255,2.346a2.584,2.584,0,0,0,.953,2.3l1.838,1.478a.592.592,0,0,1,0,.924Z', 'M16.383,7.616a1.249,1.249,0,0,0-1.767,0l-2.44,2.44a.25.25,0,0,1-.353,0l-2.44-2.44A1.25,1.25,0,0,0,7.616,9.384l2.439,2.439a.25.25,0,0,1,0,.354L7.616,14.616a1.249,1.249,0,0,0,0,1.768,1.277,1.277,0,0,0,1.767,0l2.44-2.439a.249.249,0,0,1,.353,0l2.44,2.439a1.266,1.266,0,0,0,1.767,0,1.249,1.249,0,0,0,0-1.768l-2.439-2.439a.25.25,0,0,1,0-.354l2.439-2.439A1.249,1.249,0,0,0,16.383,7.616Z']],
  CheckShieldAlternate: ['check-shield-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.218,14.792a1.249,1.249,0,0,0,1.745.029l7.105-6.695a1.25,1.25,0,1,0-1.714-1.819l-6.218,5.859L8.625,10.641A1.25,1.25,0,1,0,6.849,12.4Z', 'M20.052,0H3.947A1.954,1.954,0,0,0,2,1.955V7.947a17.982,17.982,0,0,0,9.53,15.935,1,1,0,0,0,.939,0A17.987,17.987,0,0,0,22,7.947V1.955A1.955,1.955,0,0,0,20.052,0ZM20,7.947a16,16,0,0,1-8,13.91A15.993,15.993,0,0,1,4,7.947V2.5A.5.5,0,0,1,4.5,2l15-.04a.5.5,0,0,1,.5.5Z']],
  Check2Alternate: ['check-2-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.741,6.243a1.25,1.25,0,0,0-1.748.265l-6.228,8.453L6.78,11.773a1.25,1.25,0,1,0-1.561,1.952l5,4a1.235,1.235,0,0,0,.781.269,1.254,1.254,0,0,0,1.006-.5l7-9.5A1.249,1.249,0,0,0,18.741,6.243Z', 'M22,0H2A2,2,0,0,0,0,2V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Zm0,21.75a.25.25,0,0,1-.25.25H2.25a.249.249,0,0,1-.25-.25V2.249A.249.249,0,0,1,2.25,2h19.5a.25.25,0,0,1,.25.25Z']],
  CheckCircleAlternate: ['check-circle-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.409.4A1.25,1.25,0,0,0,21.651.59L8.969,16.332,6.318,13.681A1.25,1.25,0,1,0,4.55,15.449l3.636,3.635a1.261,1.261,0,0,0,1.857-.1L23.6,2.159A1.25,1.25,0,0,0,23.409.4Z', 'M17.865,12.89a1,1,0,0,0-.932,1.064q.018.252.018.507a7.408,7.408,0,1,1-4.769-6.927A1,1,0,0,0,12.9,5.665a9.414,9.414,0,1,0,6.056,8.8c0-.215-.008-.428-.022-.64A1,1,0,0,0,17.865,12.89Z']],
  RemoveSquareAlternate: ['remove-square-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H2A2,2,0,0,0,0,2V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Zm-.25,22H2.249a.25.25,0,0,1-.25-.25V2.249A.25.25,0,0,1,2.249,2h19.5a.25.25,0,0,1,.25.25v19.5A.25.25,0,0,1,21.749,22Z', 'M6.115,17.883a1.251,1.251,0,0,0,1.768,0L12,13.767l4.116,4.116a1.25,1.25,0,0,0,1.768-1.768L13.767,12l4.116-4.116a1.25,1.25,0,0,0-1.768-1.768L12,10.232,7.883,6.115A1.25,1.25,0,0,0,6.115,7.883L10.232,12,6.115,16.115A1.251,1.251,0,0,0,6.115,17.883Z']],
  Check2: ['check-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.455,0H1.545A1.547,1.547,0,0,0,0,1.545V22.454A1.547,1.547,0,0,0,1.545,24h20.91A1.547,1.547,0,0,0,24,22.454V1.545A1.547,1.547,0,0,0,22.455,0Zm-3.65,7.844-7,9.5a1.013,1.013,0,0,1-1.43.187l-5-4a1,1,0,1,1,1.25-1.561l4.187,3.35L17.2,6.656a1,1,0,1,1,1.61,1.187Z']],
  Check1: ['check-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.374.287a1.5,1.5,0,0,0-2.093.345L7.246,20.2,2.561,15.511A1.5,1.5,0,1,0,.439,17.632l5.935,5.934a1.525,1.525,0,0,0,2.279-.186l15.066-21A1.5,1.5,0,0,0,23.374.287Z']],
  RemoveCircleAlternate: ['remove-circle-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.666,6.333a1.249,1.249,0,0,0-1.768,0l-3.722,3.722a.25.25,0,0,1-.353,0L8.1,6.333A1.25,1.25,0,1,0,6.333,8.1l3.722,3.722a.25.25,0,0,1,0,.354L6.333,15.9a1.251,1.251,0,0,0,0,1.768,1.269,1.269,0,0,0,1.768,0l3.722-3.722a.249.249,0,0,1,.353,0L15.9,17.666a1.272,1.272,0,0,0,1.768,0,1.251,1.251,0,0,0,0-1.768l-3.722-3.722a.25.25,0,0,1,0-.354L17.666,8.1A1.249,1.249,0,0,0,17.666,6.333Z', 'M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z']],
  CheckCircle1: ['check-circle-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z']],
  CheckDouble1: ['check-double-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.223,2.058a1.5,1.5,0,0,0-2.037.591L12.693,18.08,6.462,11.286a1.5,1.5,0,1,0-2.211,2.027l7.643,8.335a1.518,1.518,0,0,0,2.42-.291L23.814,4.1A1.5,1.5,0,0,0,23.223,2.058Z', 'M2.605,14.625A1.5,1.5,0,0,0,.394,16.653l4.581,5a1.517,1.517,0,0,0,2.119.091,1.5,1.5,0,0,0,.092-2.119Z', 'M10.3,12.973a1.407,1.407,0,0,0,2.01-.54L16.894,4.1a1.5,1.5,0,1,0-2.627-1.446L9.678,10.986A1.425,1.425,0,0,0,10.3,12.973Z']],
  CheckShield: ['check-shield', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20.418,0H3.582A1.5,1.5,0,0,0,2.091,1.5V7.763a18.256,18.256,0,0,0,9.675,16.178A.494.494,0,0,0,12,24a.5.5,0,0,0,.235-.058A18.261,18.261,0,0,0,21.909,7.763V1.5A1.5,1.5,0,0,0,20.418,0ZM17.9,7.945l-7.1,6.7a1,1,0,0,1-1.4-.024L7.027,12.225a1,1,0,1,1,1.421-1.407l1.682,1.7,6.395-6.027A1,1,0,1,1,17.9,7.945Z']],
  CheckSquare: ['check-square', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.816,18.04a3,3,0,0,1-4.457.24L4.841,14.763a3.113,3.113,0,0,1-.231-4.244A3,3,0,0,1,8.964,10.4l1.078,1.077a.249.249,0,0,0,.371-.02l5.681-7.052A.25.25,0,0,0,15.9,4H1.534a1.5,1.5,0,0,0-1.5,1.5v17a1.5,1.5,0,0,0,1.5,1.5h17a1.5,1.5,0,0,0,1.5-1.5V9.789a.25.25,0,0,0-.445-.157Z', 'M23.407.331A1.5,1.5,0,0,0,21.3.558L10.359,13.917,7.9,11.462a1.5,1.5,0,0,0-2.121,2.121l3.636,3.636a1.515,1.515,0,0,0,2.228-.12L23.634,2.44A1.5,1.5,0,0,0,23.407.331Z']],
  CheckCircle: ['check-circle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.842,18.321a3,3,0,0,1-4.457.24L4.869,15.044a3.112,3.112,0,0,1-.23-4.245,3,3,0,0,1,4.353-.117l1.077,1.077a.251.251,0,0,0,.372-.02l4.435-5.505a.256.256,0,0,0-.063-.377,9.752,9.752,0,1,0,4.236,5.379.254.254,0,0,0-.438-.076Z', 'M23.435.391a1.5,1.5,0,0,0-2.109.227L10.386,14.2,7.931,11.743A1.5,1.5,0,1,0,5.81,13.864L9.446,17.5a1.514,1.514,0,0,0,2.228-.12L23.662,2.5A1.5,1.5,0,0,0,23.435.391Z']],
  RemoveSquare: ['remove-square', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.455,0H1.545A1.547,1.547,0,0,0,0,1.545V22.454A1.547,1.547,0,0,0,1.545,24h20.91A1.547,1.547,0,0,0,24,22.454V1.545A1.547,1.547,0,0,0,22.455,0ZM17.707,16.292a1,1,0,0,1,0,1.414,1.028,1.028,0,0,1-1.414,0L12.177,13.59a.252.252,0,0,0-.354,0L7.707,17.706a1.02,1.02,0,0,1-1.414,0,1,1,0,0,1,0-1.414l4.116-4.116a.249.249,0,0,0,0-.353L6.293,7.706A1,1,0,0,1,7.707,6.292l4.116,4.116a.25.25,0,0,0,.354,0l4.116-4.116a1,1,0,0,1,1.414,1.414l-4.116,4.117a.249.249,0,0,0,0,.353Z']],
  RemoveBadge: ['remove-badge', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.19,10.293,21.269,8.748a1.161,1.161,0,0,1-.429-1.035l.267-2.452a2.167,2.167,0,0,0-2.386-2.388l-2.453.268a1.168,1.168,0,0,1-1.036-.429L13.688.79a2.234,2.234,0,0,0-3.376,0h0L8.768,2.711a1.163,1.163,0,0,1-1.037.43L5.28,2.873A2.167,2.167,0,0,0,2.893,5.261L3.16,7.712a1.162,1.162,0,0,1-.429,1.036L.81,10.293a2.164,2.164,0,0,0,0,3.375l1.921,1.545a1.162,1.162,0,0,1,.429,1.035L2.893,18.7a2.167,2.167,0,0,0,2.386,2.388l2.453-.268a1.169,1.169,0,0,1,1.036.429l1.544,1.922a2.167,2.167,0,0,0,3.376,0l1.544-1.922a1.174,1.174,0,0,1,1.037-.429l2.451.268A2.167,2.167,0,0,0,21.107,18.7l-.267-2.452a1.161,1.161,0,0,1,.429-1.035l1.921-1.545a2.164,2.164,0,0,0,0-3.375Zm-6.483,4.981a1,1,0,0,1,0,1.414,1.014,1.014,0,0,1-1.414,0l-3.116-3.116a.252.252,0,0,0-.354,0L8.707,16.688a1.009,1.009,0,0,1-1.414,0,1,1,0,0,1,0-1.414l3.116-3.116a.249.249,0,0,0,0-.353L7.293,8.688A1,1,0,1,1,8.707,7.274l3.116,3.117a.252.252,0,0,0,.354,0l3.116-3.117a1,1,0,1,1,1.414,1.414l-3.116,3.117a.249.249,0,0,0,0,.353Z']],
  RemoveShieldAlternate: ['remove-shield-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20.052,0H3.947A1.954,1.954,0,0,0,2,1.956V7.948a17.982,17.982,0,0,0,9.53,15.934,1,1,0,0,0,.939,0A17.984,17.984,0,0,0,22,7.948V1.956A1.955,1.955,0,0,0,20.052,0ZM20,7.948a16,16,0,0,1-8,13.909A15.99,15.99,0,0,1,4,7.948V2.5A.5.5,0,0,1,4.5,2l15-.041a.5.5,0,0,1,.5.5Z', 'M7.376,14.8a1.267,1.267,0,0,0,1.768,0l2.589-2.589a.5.5,0,0,1,.707,0L15.029,14.8a1.271,1.271,0,0,0,1.767,0,1.248,1.248,0,0,0,0-1.767l-2.588-2.589a.5.5,0,0,1,0-.707L16.8,7.143a1.25,1.25,0,0,0-1.767-1.768L12.44,7.964a.5.5,0,0,1-.707,0L9.144,5.375A1.25,1.25,0,0,0,7.376,7.143L9.965,9.732a.5.5,0,0,1,0,.707L7.376,13.028A1.249,1.249,0,0,0,7.376,14.8Z']],
  CheckDouble: ['check-double', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M5.532,15.06a1.5,1.5,0,0,1,0-2.119L4,11.409a1,1,0,0,0-1.414,0L.543,13.452a1,1,0,0,0,0,1.414l4.793,4.793a1,1,0,0,0,1.414,0l1.514-1.513a.25.25,0,0,0,0-.354Z', 'M9.7,10.9l1.512,1.511a.25.25,0,0,0,.354,0l6.362-6.362a.25.25,0,0,0,0-.354L16.571,4.338a1,1,0,0,0-1.414,0L8.985,10.51A1.445,1.445,0,0,1,9.7,10.9Z', 'M21.561,4.531a.5.5,0,0,0-.707,0l-9.115,9.115a.5.5,0,0,1-.707,0L8.989,11.6a.5.5,0,0,0-.707,0L6.239,13.646a.5.5,0,0,0,0,.707l4.793,4.793a.5.5,0,0,0,.707,0L23.6,7.282a.5.5,0,0,0,0-.707Z']],
  Close: ['close', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.3,12.179a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.442L12.177,9.7a.25.25,0,0,1-.354,0L2.561.442A1.5,1.5,0,0,0,.439,2.563L9.7,11.825a.25.25,0,0,1,0,.354L.439,21.442a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,0,0,2.122-2.121Z']],
  RemoveCircle: ['remove-circle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm5.49,16.076a1,1,0,1,1-1.414,1.414l-3.9-3.9a.252.252,0,0,0-.354,0l-3.9,3.9a1.012,1.012,0,0,1-1.414,0,1,1,0,0,1,0-1.414l3.9-3.9a.249.249,0,0,0,0-.353l-3.9-3.9A1,1,0,0,1,7.924,6.51l3.9,3.9a.25.25,0,0,0,.354,0l3.9-3.9A1,1,0,1,1,17.49,7.924l-3.9,3.9a.249.249,0,0,0,0,.353Z']],
  CheckButton: ['check-button', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,8a3,3,0,0,0-3-3H3A3,3,0,0,0,0,8v8a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-2,8a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V8A1,1,0,0,1,3,7H21a1,1,0,0,1,1,1Z', 'M18.629,9.6l-1.892,2.366a.254.254,0,0,1-.182.093.246.246,0,0,1-.19-.073l-1.073-1.072A1.05,1.05,0,0,0,13.808,12.4l2.1,2.1a1.071,1.071,0,0,0,1.563-.087l2.8-3.5A1.051,1.051,0,0,0,18.629,9.6Z']],
  RemoveShield: ['remove-shield', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20.419,0H3.581a1.5,1.5,0,0,0-1.49,1.5V7.764a18.256,18.256,0,0,0,9.675,16.177A.5.5,0,0,0,12,24a.5.5,0,0,0,.235-.059A18.259,18.259,0,0,0,21.909,7.764V1.5A1.5,1.5,0,0,0,20.419,0ZM16.62,13.2a1,1,0,0,1,0,1.414,1.009,1.009,0,0,1-1.414,0L12.44,11.853a.5.5,0,0,0-.707,0L8.968,14.618a1.031,1.031,0,0,1-1.414,0,1,1,0,0,1,0-1.414l2.765-2.765a.5.5,0,0,0,0-.708L7.554,6.966A1,1,0,1,1,8.968,5.552l2.765,2.765a.5.5,0,0,0,.707,0l2.766-2.765A1,1,0,0,1,16.62,6.966L13.855,9.731a.5.5,0,0,0,0,.708Z']],
  CheckSquareAlternate: ['check-square-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.409.4A1.249,1.249,0,0,0,21.651.59L10.025,15.007,6.008,10.99A1.25,1.25,0,0,0,4.24,12.758l5,5a1.263,1.263,0,0,0,1.857-.1l12.5-15.5A1.249,1.249,0,0,0,23.409.4Z', 'M19.124,11.374a1,1,0,0,0-1,1v9.25a.25.25,0,0,1-.25.25H2.374a.25.25,0,0,1-.25-.25V6.124a.25.25,0,0,1,.25-.25h11.25a1,1,0,1,0,0-2H2.124a2,2,0,0,0-2,2v16a2,2,0,0,0,2,2h16a2,2,0,0,0,2-2v-9.5A1,1,0,0,0,19.124,11.374Z']],
  CursorChoose1: ['cursor-choose-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M4.8,7,8.707,1.79a1,1,0,0,0-1.6-1.2L3.892,4.878,1.707,2.694A1,1,0,0,0,.293,4.108l3,3A1.013,1.013,0,0,0,4.8,7Z', 'M21.762,3.749l1.945-1.944A1,1,0,0,0,22.293.39L20.348,2.335,18.4.39a1,1,0,0,0-1.414,1.415l1.944,1.944L16.989,5.694a1,1,0,0,0,0,1.414,1.015,1.015,0,0,0,1.414,0l1.945-1.945,1.945,1.945a1.017,1.017,0,0,0,1.414,0,1,1,0,0,0,0-1.414Z', 'M18.074,14.68,13,12.857V7.4a2,2,0,0,0-4,0v8.461l-.827-1.139a1.546,1.546,0,0,0-1.2-.558l-.99.02a1.476,1.476,0,0,0-1.3,2.178l3.735,6.773A1.462,1.462,0,0,0,9.7,23.9h6.386a1.479,1.479,0,0,0,1.379-.99l.594-2.609.837-3.679A1.523,1.523,0,0,0,18.074,14.68Z']],
  CheckBadgeAlternate: ['check-badge-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.416,8a1.251,1.251,0,0,0-1.75.25L10.931,13.23,8.883,11.182a1.249,1.249,0,0,0-1.767,1.767l2.441,2.442a2.043,2.043,0,0,0,3.04-.216l4.069-5.426A1.25,1.25,0,0,0,16.416,8Z', 'M23.031,9.978,21.193,8.5a.6.6,0,0,1-.218-.528l.255-2.345a2.593,2.593,0,0,0-2.859-2.859l-2.346.255a.584.584,0,0,1-.526-.218L14.021.967a2.594,2.594,0,0,0-4.042,0h0L8.5,2.805a.592.592,0,0,1-.527.219L5.628,2.769A2.592,2.592,0,0,0,2.769,5.627l.255,2.347a.589.589,0,0,1-.217.526L.968,9.978a2.594,2.594,0,0,0,0,4.042L2.806,15.5a.591.591,0,0,1,.218.529L2.769,18.37a2.594,2.594,0,0,0,2.859,2.86l2.346-.256a.585.585,0,0,1,.526.218L9.979,23.03a2.592,2.592,0,0,0,4.042,0L15.5,21.193a.6.6,0,0,1,.527-.219l2.346.256a2.594,2.594,0,0,0,2.859-2.859l-.255-2.347a.589.589,0,0,1,.217-.526l1.839-1.478a2.592,2.592,0,0,0,0-4.042Zm-1.253,2.483-1.839,1.478a2.582,2.582,0,0,0-.953,2.3l.256,2.347a.593.593,0,0,1-.17.483.585.585,0,0,1-.484.17l-2.347-.255a2.583,2.583,0,0,0-2.3.953l-1.478,1.839a.619.619,0,0,1-.925,0L10.06,19.939a2.579,2.579,0,0,0-2.017-.969,2.505,2.505,0,0,0-.286.016l-2.346.255a.583.583,0,0,1-.483-.17.591.591,0,0,1-.171-.484l.256-2.344a2.583,2.583,0,0,0-.953-2.3L2.221,12.461a.594.594,0,0,1,0-.925L4.06,10.059a2.582,2.582,0,0,0,.953-2.3L4.757,5.41a.592.592,0,0,1,.654-.653l2.347.255a2.584,2.584,0,0,0,2.3-.953l1.478-1.838a.619.619,0,0,1,.925,0l1.477,1.839a2.58,2.58,0,0,0,2.3.953l2.346-.255a.594.594,0,0,1,.654.654l-.256,2.347a2.588,2.588,0,0,0,.953,2.3l1.838,1.477a.592.592,0,0,1,0,.925Z']],
  CursorChoose: ['cursor-choose', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M4.07,8.39A.994.994,0,0,0,4.8,8l3.907-5.21a1,1,0,0,0-1.6-1.2L3.892,5.878,1.707,3.694A1,1,0,0,0,.293,5.108l3,3A1,1,0,0,0,4.07,8.39Z', 'M21.762,4.749l1.945-1.944a1,1,0,1,0-1.414-1.414L20.348,3.335,18.4,1.391a1,1,0,1,0-1.414,1.414l1.944,1.944L16.989,6.694a1,1,0,0,0,0,1.414,1.011,1.011,0,0,0,1.414,0l1.945-1.945,1.945,1.945a1.013,1.013,0,0,0,1.414,0,1,1,0,0,0,0-1.414Z', 'M16.878,15.9H14V9.276a2.375,2.375,0,0,0-4.75,0v9.311L7.911,16.708a2.156,2.156,0,0,0-2.8-.87,2.1,2.1,0,0,0-.87,2.8l2.1,3.992a.5.5,0,0,0,.443.267H21a.5.5,0,0,0,.5-.5V20.748A4.862,4.862,0,0,0,16.878,15.9Z']],
  CheckBadge: ['check-badge', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.718,10.35,20.88,8.872a1.092,1.092,0,0,1-.4-.971l.255-2.345a2.091,2.091,0,0,0-2.307-2.308L16.08,3.5a1.093,1.093,0,0,1-.971-.4L13.631,1.263a2.157,2.157,0,0,0-3.262,0L8.891,3.1a1.086,1.086,0,0,1-.971.4L5.575,3.248A2.091,2.091,0,0,0,3.267,5.555L3.522,7.9a1.087,1.087,0,0,1-.4.971L1.282,10.35a2.092,2.092,0,0,0,0,3.262L3.12,15.09a1.088,1.088,0,0,1,.4.971l-.255,2.345a2.091,2.091,0,0,0,2.307,2.308l2.346-.255a1.092,1.092,0,0,1,.971.4L10.369,22.7a2.092,2.092,0,0,0,3.262,0l1.478-1.838a1.093,1.093,0,0,1,.971-.4l2.345.255a2.091,2.091,0,0,0,2.308-2.307l-.255-2.346a1.086,1.086,0,0,1,.4-.971l1.838-1.478a2.092,2.092,0,0,0,0-3.262ZM12.4,15.048a1.785,1.785,0,0,1-2.663.19L7.293,12.8a1,1,0,1,1,1.414-1.414l2.251,2.251,3.909-5.211a1,1,0,1,1,1.6,1.2Z']],
  Check: ['check', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.146,5.4,20.354,2.6a.5.5,0,0,0-.708,0L7.854,14.4a.5.5,0,0,1-.708,0L4.354,11.6a.5.5,0,0,0-.708,0L.854,14.4a.5.5,0,0,0,0,.707L7.146,21.4a.5.5,0,0,0,.708,0L23.146,6.1A.5.5,0,0,0,23.146,5.4Z']],
  CheckCircle1Alternate: ['check-circle-1-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.48,6.449a1.249,1.249,0,0,0-1.747.265l-5.924,8.04L7.042,11.74a1.251,1.251,0,0,0-1.563,1.953l4.783,3.826a1.263,1.263,0,0,0,1.787-.235l6.7-9.087A1.25,1.25,0,0,0,18.48,6.449Z', 'M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z']]
};
exports["default"] = _default;